import React from 'react';
import { TableRow, TableCell, Box } from '@material-ui/core';

const TablePlaceHolder = ({ placeholder }) => {
  return (
    <TableRow>
      <TableCell colSpan='10000'>
        <Box
          minHeight={350}
          display='flex'
          flexDirection='column'
          textAlign='center'
          alignItems='center'
          justifyContent='center'>
          {placeholder || 'No data'}
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default TablePlaceHolder;
